export default {
  app: {
    client_id: 'String',
    client_secret: 'String',
  },
}
